var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payment-request-button',{attrs:{"stripe":_vm.stripe,"options":_vm.options},on:{"token":function (event) { return _vm.$emit('token', event); }}})}
var staticRenderFns = []

export { render, staticRenderFns }